import React from 'react';
import { FileText, MessageCircle, BarChart2, CheckCircle, MessageSquare, Zap, Download } from 'lucide-react';

const DifferentiationSection = () => {
  const features = [
    {
      icon: FileText,
      title: "백지에서 시작 가능",
      description: "기존 이력서 없어도 OK. 처음부터 라뗴컨설턴트와 함께 만들어 드립니다."
    },
    {
      icon: MessageCircle,
      title: "대화 기반 경험 발굴",
      description: "자연스러운 대화에서 진짜 경험을 캐치. 작은 에피소드도 놓치지 않고 경력으로 기록."
    },
    {
      icon: BarChart2,
      title: "성과로의 전환",
      description: "경험을 정량적 성과로 변환. 채용담당자가 주목하는 결과 중심 이력서."
    },
    {
      icon: CheckCircle,
      title: "JD 기반 맞춤형",
      description: "지원 포지션 및 개인 경험에 맞춘 최적 질문과 맞춤형 결과물."
    }
  ];

  const steps = [
    {
      icon: MessageSquare,
      title: "대화하기",
      description: "라떼이즈 컨설턴트에게 당신의 경험을 들려주세요"
    },
    {
      icon: Zap,
      title: "실시간 분석",
      description: "대화 중 이력서가 실시간으로 자동 완성됩니다"
    },
    {
      icon: Download,
      title: "결과물 제공",
      description: "프리미엄 템플릿, 맞춤형 자소서, 웹페이지 즉시 생성"
    }
  ];

  return (
    <section className="differentiation-section">
      <div className="container">
        <div className="combined-content">
          <div className="process-section-compact">
            <h2 className="section-title-compact">30분이면 충분합니다</h2>
            <div className="process-grid-compact">
              {steps.map((step, index) => (
                <div key={index} className="process-card-compact">
                  <div className="process-step-number">{index + 1}</div>
                  <div className="process-content">
                    <h3 className="process-title-compact">{step.title}</h3>
                    <p className="process-desc-compact">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="features-section-compact">
            <h2 className="section-title-compact">라떼이즈, 뭐가 다를까요?</h2>
            <div className="features-grid-compact">
              {features.map((feature, index) => (
                <div key={index} className="feature-card-compact">
                  <div className="feature-icon-wrapper-compact">
                    <feature.icon className="feature-icon-compact" strokeWidth={1.5} />
                  </div>
                  <div className="feature-content">
                    <h3 className="feature-title-compact">{feature.title}</h3>
                    <p className="feature-desc-compact">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferentiationSection;
